import { date, object, string } from 'yup';

import { GetActivityRequest } from '../categorization.types';

export const activityInitialValue = (userId: string): GetActivityRequest => ({
  userId,
  roomId: '',
  startDate: undefined,
  endDate: undefined,
});

export const activityValidation = object({
  userId: string().required().label('User Id'),
  roomId: string().required().label('Room Id'),
  startDate: date().notRequired().label('Start Date'),
  endDate: date().notRequired().label('End Date'),
});
